import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { MOBILE_APP, fadeInUp, stagger } from './data';

const MOBILE_FEATURES = [
  'Responsive design for phones, tablets, and desktops',
  'Native iOS and Android apps via Capacitor',
  'Real-time push notifications for service calls and alerts',
  'Email notifications for payments, trials, and status updates',
  'Multi-company dashboard with global company filter',
];

export const MobileSection = () => (
  <section aria-label="Mobile App and Real-time Notifications" className="py-20 md:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="order-2 lg:order-1"
        >
          <div className="relative max-w-sm mx-auto overflow-hidden">
            <div className="absolute -inset-4 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" />
            <img
              src={MOBILE_APP}
              srcSet="/images/mobile-app-640.webp 640w, /images/mobile-app.webp 896w"
              sizes="(max-width: 768px) 100vw, 384px"
              alt="SlotFleet Mobile App - Manage Skill Games Business from Any Device"
              className="relative"
              width={896}
              height={1280}
              loading="lazy"
            />
          </div>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="order-1 lg:order-2"
        >
          <motion.p variants={fadeInUp} className="text-yellow-400 font-semibold mb-4">
            MOBILE FRIENDLY & REAL-TIME
          </motion.p>
          <motion.h2 variants={fadeInUp} className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Manage Your Business From Anywhere
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-gray-400 text-lg mb-8">
            Fully responsive design that works beautifully on any device. Get instant
            notifications for service calls, collections, and subscription events —
            so you never miss a beat.
          </motion.p>
          <motion.ul variants={stagger} className="space-y-4">
            {MOBILE_FEATURES.map((item, i) => (
              <motion.li key={`mobile-feature-${i}`} variants={fadeInUp} className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-yellow-500/20 flex items-center justify-center">
                  <Check className="w-4 h-4 text-yellow-400" />
                </div>
                <span className="text-gray-300">{item}</span>
              </motion.li>
            ))}
          </motion.ul>
        </motion.div>
      </div>
    </div>
  </section>
);
